import { useEffect, useState } from "react";
import { MdArrowBack } from "react-icons/md";
import { FaSave } from "react-icons/fa";
import { Link } from "react-router-dom";
import Loading from "../../Components/Loading/Loading";

import PurposesArea from "./Components/PurposesArea/PurposesArea";

// Candidate
import { getPurposeCandidateList, getAllPurposesCandidate, patchPurposeCandidate } from "../../API/Candidates/Purpose";
import { myPurposesTranslate } from "../../i18n/translatedMessages";
import { btnTranslate } from "../../i18n/translatedMessages";

import { PropositoIcon } from "../../Icons/CollaboratorsIcons";
import Swal from "sweetalert2";

const B2EProposito = () => {
  //   const user = JSON.parse(localStorage.getItem('user'));

  const [dataPurposeCandidate, setDataPurposeCandidate] = useState({ items: [] });
  const [listPurposeCandidate, setListPurposeCandidate] = useState([]);

  const [loading, setLoading] = useState(false);

  const fetchPurposeCandidate = async () => {
    setLoading(true);
    const dataPurposeCandidate = await getPurposeCandidateList(localStorage.getItem("candidateId"));
    const dataAllPurposeCandidate = await getAllPurposesCandidate();
    setListPurposeCandidate(dataAllPurposeCandidate);
    if (dataPurposeCandidate.items?.length > -1) {
      setDataPurposeCandidate(dataPurposeCandidate);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPurposeCandidate();
  }, []);

  const handleChose = (event, item) => {
    setDataPurposeCandidate({
      ...dataPurposeCandidate,
      items: [...dataPurposeCandidate.items, { id: item.purposeId, name: item.purposeName }],
    });
  };

  const handlePopItem = (id) => {
    const updatedItems = dataPurposeCandidate?.items?.filter((existingItem) => existingItem.id !== id);
    setDataPurposeCandidate({
      ...dataPurposeCandidate,
      items: updatedItems,
    });
  };

  useEffect(() => {}, [dataPurposeCandidate]);

  const handleSend = async () => {
    const data = [];

    for (let i = 0; i < dataPurposeCandidate.items.length; i++) {
      data.push(dataPurposeCandidate.items[i].id);
    }

    const resp = await patchPurposeCandidate(data, localStorage.getItem("candidateId"));
    if (resp.status === 200) {
      Swal.fire({
        title: "El envío se ha efectuado con exito!",
        text: "",
        icon: "success",
        showCancelButton: false,
        showConfirmButton: true,
      });
    } else {
      Swal.fire({
        title: "Hola 👋",
        text: "Algo ha ido mal, inténtalo más tarde!",
        icon: "info",
        confirmButtonText: "Ok",
      });
    }
  };

  return (
    <div className="container-fluid purpose purpose-main sideMenuSeparator">
      <div className="row">
        <div className="col-12">
          <div className="proposito-b2c">
            <div className="row mb-4">
              <div className="col-2">
                <span className="title-icon p-2 m-auto">
                  <PropositoIcon size={20} />
                </span>
              </div>
              <div className="col-10">
                <h1>{myPurposesTranslate.myPurposes}</h1>
              </div>
            </div>
            <div className="row">
              <p className="description-section">{myPurposesTranslate.myPurposeText}</p>
            </div>

            {loading ? (
              <Loading />
            ) : (
              <div className="row">
                <div className="col">
                  <PurposesArea myList={dataPurposeCandidate} allPurposes={listPurposeCandidate} handleChose={handleChose} handlePopItem={handlePopItem} />
                </div>
              </div>
            )}
            <div className="row mt-4">
              <div className="col d-flex justify-content-end">
                <button className="btn btn-save" onClick={handleSend}>
                  <FaSave size="18" />
                  <span className="fs-5 ms-3">{btnTranslate.saveButton}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default B2EProposito;
